<template>
    <v-sheet class="overflow-hidden fill-height"
             style="position: relative; border-radius: 0 !important;">
        <v-btn dark
               small
               class="menu-btn"
               @click.stop="drawer = !drawer">
            <v-icon>{{ icons.menu }}</v-icon>
        </v-btn>

        <div @click="drawer = false" class="fill-height">
            <slot>
            </slot>
        </div>

        <v-navigation-drawer
            v-model="drawer"
            fixed
            style="z-index: 5"
            dark>
            <v-container fluid class="py-0">
                <v-row
                    justify="center"
                    align="center">
                    <v-col cols="10" class="pa-1">
                        <v-btn @click.stop="goTo({to: 'main'})" text
                               class="pa-1 white--text text-none font-weight-black">
                            <div class="shop-name">{{ shop.name }}</div>
                        </v-btn>
                    </v-col>
                    <v-col cols="2" class="text-center pa-1" style="cursor: pointer">
                        <v-btn @click.stop="drawer = false" icon>
                            <v-icon>{{ icons.close }}</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
            </v-container>

            <v-divider></v-divider>

            <v-list
                dense
                nav
                class="pt-0 mb-12 px-4">
                <v-container v-if="has_perm('renew_site')" fluid class="py-0">
                    <v-row
                        align="center"
                        justify="center">
                        <v-col class="text-center">
                            <v-chip @click="showRenewSubscription" v-if="subscription_ending_date > date_now" small
                                    color="success">Активен до
                                {{ str_subscription_ending_date }}
                            </v-chip>
                            <v-chip v-else @click="showEndSubscription" small color="error">Сайт не активен</v-chip>
                        </v-col>
                    </v-row>
                </v-container>

                <v-divider v-if="shop.owner === client.user.id"></v-divider>

                <v-container fluid class="py-0">
                    <v-row
                        align="center"
                        justify="center">
                        <v-col cols="3" class="pl-0 pr-2 text-center">
                            <v-avatar height="50" width="50">
                                <img
                                    src="https://icons.iconarchive.com/icons/papirus-team/papirus-status/512/avatar-default-icon.png"
                                    alt="Profile">
                            </v-avatar>
                        </v-col>
                        <v-col cols="7" class="pl-1 pr-0 body-2 font-regular">
                            {{ client.user.first_name|truncate(12) }}
                            {{ client.user.last_name|truncate(12) }}
                        </v-col>
                        <v-col cols="2" class="text-center pa-1">
                            <v-tooltip right>
                                <template v-slot:activator="{ on }">
                                    <v-btn v-on="on" @click.stop="logout" icon style="color: rgb(128,128,128)">
                                        <v-icon>{{ icons.exit }}</v-icon>
                                    </v-btn>
                                </template>
                                <span>Выход из аккаунта</span>
                            </v-tooltip>
                        </v-col>
                    </v-row>
                </v-container>

                <v-divider class="mb-4"></v-divider>

                <v-container fluid class="py-1 secondary lighten-1" style="border-radius: 5px">
                    <v-row align="center" justify="center">
                        <v-col cols="5" class="py-0 pr-0">
                            <div class="caption" style="color: #9b9b9b">Баланс</div>
                            <div class="body-2 font-weight-regular text-no-wrap">
                                {{ client.balance }}
                                <v-icon size="15" style="position: relative; bottom: 1px; right: 2.5px">{{ icons.rub }}
                                </v-icon>
                            </div>
                        </v-col>
                        <v-col cols="7" class="py-0" style="padding-right: 6px">
                            <v-btn @click="onPayment(false)" dark depressed block color="green"
                                   class="text-none body-2 font-weight-regular">
                                Пополнить
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-container>
                <v-btn @click="onPayment(true)" small text block class="mt-1 mb-4 text-none caption font-weight-regular"
                       :disabled="client.balance <= 0">
                    <v-icon size="19" style="position: absolute; left: -9px" color="green">{{ icons.return }}</v-icon>
                    Возврат денежных средств
                </v-btn>

                <v-divider></v-divider>

                <v-list-item v-for="item in items"
                             v-show="item.show"
                             :key="item.title"
                             :to="{name: item.to, params: item.params}"
                             class="my-2"
                             link
                >
                    <v-list-item-icon class="mr-3">
                        <v-icon size="22">{{ item.icon }}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title class="body-2 font-weight-regular">
                            {{ item.title }}
                        </v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action v-if="item.count !== undefined && item.count !== 0" class="pt-3">
                        <v-badge color="warning" :content="`${item.count}`"></v-badge>
                    </v-list-item-action>
                </v-list-item>

                <v-list-item v-if="shop.access_token">
                    <v-container fluid class="pa-0">
                        <v-row class="pa-0" justify="center">
                            <v-col cols="12" style="max-width: 189px;" class="px-0">
                                <vk-allow-messages style="margin-right: auto; margin-left: auto" :height="30"
                                                   :group-id="parseInt(shop.vk_group_id)"></vk-allow-messages>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-list-item>

            </v-list>

            <v-footer absolute class="pa-0" style="border-top: 1px solid #4e4e4e">
                <v-container v-if="shop.owner === client.user.id" fluid>
                    <v-row justify="center">
                        <v-btn href="https://vk.me/posredpro" target="_blank" depressed small>
                            <v-icon left>mdi-face-agent</v-icon>
                            Нужна помощь?
                        </v-btn>
                    </v-row>
                </v-container>
            </v-footer>

        </v-navigation-drawer>

        <payment-dialog/>
        <end-subscription-dialog/>
        <publication-dialog/>
        <search-subscription-dialog/>

    </v-sheet>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import {
    mdiShopping,
    mdiPlus,
    mdiCurrencyRub,
    mdiExitToApp,
    mdiImageMultiple,
    mdiPackageVariant,
    mdiAccountMultipleOutline,
    mdiCashMultiple,
    mdiHistory,
    mdiBell,
    mdiAndroidMessages,
    mdiCog,
    mdiClose,
    mdiMenu,
    mdiKeyboardReturn, mdiCalendarMonth, mdiHeart,
    // mdiClipboardListOutline
} from '@mdi/js'
import PaymentDialog from "./payments/PaymentDialog";
import EventBus from "../event-bus";
import VkAllowMessages from 'vue-vk/src/components/VKAllowCommunityMessages/VKAllowCommunityMessages'
import EndSubscriptionDialog from "./other/EndSubscriptionDialog";
import { format } from 'date-fns'
import PublicationDialog from "@/components/collections/PublicationDialog";
import SearchSubscriptionDialog from "@/components/catalog/SearchSubscriptionDialog.vue";

export default {
    name: "Menu",
    components: {SearchSubscriptionDialog, PublicationDialog, EndSubscriptionDialog, PaymentDialog, VkAllowMessages},
    data() {
        return {
            icons: {
                plus: mdiPlus,
                rub: mdiCurrencyRub,
                exit: mdiExitToApp,
                bell: mdiBell,
                msg: mdiAndroidMessages,
                cog: mdiCog,
                close: mdiClose,
                menu: mdiMenu,
                return: mdiKeyboardReturn,
            },
            payments_count: 0,
            drawer: false,
            items: [],
        }
    },
    computed: {
        ...mapState({
            shop: state => state.shop.shop,
            client: state => state.clients.current_client,
            logout_loading: state => state.auth.logout_loading,
        }),
        ...mapGetters('clients', [
            'has_perm',
        ]),
        str_subscription_ending_date() {
            return format(this.subscription_ending_date, 'dd.MM.yyyy HH:mm')
        },
        subscription_ending_date() {
            return new Date(Date.parse(this.shop.subscription_ending_date))
        },
        date_now() {
            return this.$dateNow()
        }
    },
    methods: {
        logout() {
            this.$store.dispatch('auth/logout');
        },
        goTo(item) {
            if (this.$router.history.current.name !== item.to) {
                this.$router.push({name: item.to, params: item.params});
            }
        },
        onPayment(refund) {
            EventBus.$emit('payment_dialog', {client_id: this.client.id, value: 0, refund: refund})
        },
        showEndSubscription() {
            EventBus.$emit('end_subscription_dialog', {
                text: 'Доступ к изменению информации на сайт запрещен. Необходимо продлить подписку на ваш сайт.',
                subtitle: '<span style="color: red">ОКОНЧЕНА</span>'
            })
        },
        showRenewSubscription() {
            EventBus.$emit('end_subscription_dialog', {
                text: 'Укажите кол-во месяцев на которое хотите продлить сайт.',
                subtitle: '<span class="text-success">ПРОДЛЕНИЕ</span>'
            })
        }
    },
    async mounted() {

        const vm = this;

        if (vm.shop.owner === vm.client.user.id) {
            const date_interval = vm.subscription_ending_date - vm.date_now;
            if (date_interval < 259200000 && date_interval > 0) {
                EventBus.$emit('end_subscription_dialog', {
                    text: 'В скором времени доступ к изменению информации на сайте будет запрещен. Необходимо продлить подписку на ваш сайт.',
                    subtitle: 'Скоро окончится'
                })
            } else if (date_interval < 0) {
                EventBus.$emit('end_subscription_dialog', {
                    text: 'Доступ к изменению информации на сайт запрещен. Необходимо продлить подписку на ваш сайт.',
                    subtitle: '<span style="color: red">ОКОНЧЕНА</span>'
                })
            }
        }

        const accept_payments = vm.has_perm('accept_payments')
        const settings_site = vm.has_perm('settings_site')

        if (accept_payments) {
            vm.payments_count = await vm.$store.dispatch('payments/getCountPayment')
        }

        vm.items = [
            {
                title: 'Каталог',
                icon: mdiShopping,
                to: 'catalog',
                show: vm.shop.market !== 'tagansky-ryad'
            },
            {
                title: 'Избранное',
                icon: mdiHeart,
                to: 'favourites',
                show: vm.shop.market !== 'tagansky-ryad'
            },
            {
                title: 'Альбомы',
                icon: mdiImageMultiple,
                to: 'albums',
                params: {client_id: vm.client.id},
                show: true
            },
            // {title: 'Каталог', icon: mdiHanger},
            {title: 'Сборы', icon: mdiPackageVariant, to: 'collections', show: true},
            {title: 'Закупки', icon: mdiCalendarMonth, to: 'purchases', show: true},
            {
                title: 'Клиенты',
                icon: mdiAccountMultipleOutline,
                to: 'clients',
                show: vm.has_perm('access_to_clients')
            },
            {
                title: 'Платежи',
                icon: mdiCashMultiple,
                to: accept_payments ? 'payments' : 'payments_client',
                params: {client_id: accept_payments ? undefined : vm.client.id},
                show: true,
                count: vm.payments_count
            },
            {
                title: 'История баланса',
                icon: mdiHistory,
                to: 'balance_histories',
                params: {client_id: vm.client.id},
                show: true,
            },
            // {
            //     title: 'История закупок',
            //     icon: mdiClipboardListOutline,
            //     to: 'client_purchase_history',
            //     params: {client_id: vm.client.id},
            //     show: true,
            // },
            {title: 'Настройки сайта', icon: mdiCog, to: 'settings', show: settings_site},
        ];

        if (vm.$metrika) {
            vm.$metrika.userParams({
                UserID: vm.client.user.id,
                client_id: vm.client.id,
                number: vm.client.number,
                first_name: vm.client.user.first_name,
                last_name: vm.client.user.last_name,
            })
        }
    }
}
</script>

<style scoped>
.shop-name {
    overflow: hidden;
    text-overflow: ellipsis;
    width: 210px;
}

.menu-btn {
    position: fixed;
    z-index: 2;
    top: 10px;
    left: -10px;
    padding-left: 15px !important;
    padding-right: 5px !important;
    height: 38px !important;
}
</style>